<template>
  <div class="activity-item-container font-weight-medium px-4" @click.stop="onActivityClick">
    <v-list-item class="py-4">
      <div class="d-flex gap-2">
        <user-avatar :user="{ display_name: 'activity', avatar_url: activity.image_url }" />
        <div class="d-flex flex-grow-1">
          <div class="d-flex flex-shrink-1 align-center">
            <div class="font-size-big truncate-multiline-2" :class="{ 'font-weight-bold': !markedAsSeen }">{{ activity.text }}</div>
          </div>
          <div class="info-container d-flex flex-column flex-grow-1 flex-shrink-0 align-end ml-6">
            <div class="font-size-medium color-post-detail-50">{{ timeAgo }}</div>
            <div v-if="!markedAsSeen">
              <div class="background-post-tint rounded-circle unread-marker" />
            </div>
          </div>
        </div>
      </div>
    </v-list-item>
    <v-divider class="border-post-detail-10" />
  </div>
</template>

<script>
import * as activitiesApi from "@/api/activitiesApi.js"

import * as dates from "@/services/dates.js"
import * as urls from "@/services/urls.js"
import * as paywallService from "@/services/paywallService.js"
import { paywallSourceTypes } from "@/constants/paywall.js"

export default {
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      markedAsSeen: this.activity.seen
    }
  },
  computed: {
    timeAgo() {
      return dates.getFormattedShortTime(this.activity.happened_at)
    }
  },
  methods: {
    onActivityClick() {
      const url = urls.getRouterRouteFromDeepLink(this.activity.action_v2 || this.activity.action)
      if (url) {
        if (url.name === this.$routes.POST) {
          this.$eventBus.$emit("activity-post-click", { postId: Number(url.params.postId) })
        } else if (url.name === this.$routes.PROFILE) {
          this.$eventBus.$emit("activity-profile-click", { userId: Number(url.params.id) })
        }

        this.$eventBus.$emit("activity-item-click")
        if (url.name === this.$routes.PAYWALL) {
          paywallService.registerLastSource({ sourceId: this.activity.id, sourceType: paywallSourceTypes.NOTIFICATION })
        }

        this.$router.push(url)
      }

      if (!this.activity.seen) {
        activitiesApi.markAsSeen(this.activity.id)
        this.markedAsSeen = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-item-container {
  &:hover {
    background-color: var(--post-detail-15);
  }

  :deep(.v-list-item) {
    cursor: pointer;
    height: auto;
    padding: 0;

    //ios safari fix
    .v-list-item__content {
      height: auto;
      line-height: 130%;
    }

    .info-container {
      min-height: 40px;
      .unread-marker {
        width: 10px;
        height: 10px;
      }
    }
  }
}
</style>
